import { createSlice } from "@reduxjs/toolkit";

const observationSlice = createSlice({
    name: "observations",
    initialState: {},
    reducers: {
        registerObservation: (state, action) => {
            const obs = action.payload;
            if (!obs?.id) return;

            if (!state[obs.id]) {
                state[obs.id] = obs;
            } else {
                console.warn(
                    `⚠️ Observation ${obs.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterObservations: (state, action) => {
            action.payload.forEach((obs) => {
                if (!obs?.id) return;

                if (!state[obs.id]) {
                    state[obs.id] = obs;
                } else {
                    console.warn(
                        `⚠️ Observation ${obs.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const { registerObservation, bulkRegisterObservations } = observationSlice.actions;
export default observationSlice.reducer;
